function quadOut(t) {
  return -t * (t - 2.0)
}

module.exports = quadOut


//////////////////
// WEBPACK FOOTER
// ./~/eases/quad-out.js
// module id = 151
// module chunks = 0